export default __webpack_public_path__ + "static/media/23.f0fd797b.svg";